/* eslint-disable import/prefer-default-export */

export const COUNTRY_REGION = Object.freeze({
  US: {
    name: 'United States',
    regions: {
      AL: 'Alabama',
      AK: 'Alaska',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      FL: 'Florida',
      GA: 'Georgia',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PA: 'Pennsylvania',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    },
  },
  CA: {
    name: 'Canada',
    regions: {
      AB: 'Alberta',
      BC: 'British Columbia',
      MB: 'Manitoba',
      NB: 'New Brunswick',
      NL: 'Newfoundland and Labrador',
      NS: 'Nova Scotia',
      ON: 'Ontario',
      PE: 'Prince Edward Island',
      QC: 'Quebec',
      SK: 'Saskatchewan',
      NT: 'Northwest Territories',
      NU: 'Nunavut',
      YT: 'Yukon',
    },
  },
  GB: {
    name: 'United Kingdom',
    regions: {
      ENG: 'England',
      SCT: 'Scotland',
      WLS: 'Wales',
      NIR: 'Northern Ireland',
    },
  },
  AU: {
    name: 'Australia',
    regions: {
      ACT: 'Australian Capital Territory',
      NSW: 'New South Wales',
      NT: 'Northern Territory',
      QLD: 'Queensland',
      SA: 'South Australia',
      TAS: 'Tasmania',
      VIC: 'Victoria',
      WA: 'Western Australia',
    },
  },
  DE: {
    name: 'Germany',
    regions: {
      BW: 'Baden-Württemberg',
      BY: 'Bavaria',
      BE: 'Berlin',
      BB: 'Brandenburg',
      HB: 'Bremen',
      HH: 'Hamburg',
      HE: 'Hesse',
      MV: 'Mecklenburg-Vorpommern',
      NI: 'Lower Saxony',
      NW: 'North Rhine-Westphalia',
      RP: 'Rhineland-Palatinate',
      SL: 'Saarland',
      SN: 'Saxony',
      ST: 'Saxony-Anhalt',
      SH: 'Schleswig-Holstein',
      TH: 'Thuringia',
    },
  },
  FR: {
    name: 'France',
    regions: {
      FR_ARA: 'Auvergne-Rhône-Alpes',
      FR_BFC: 'Bourgogne-Franche-Comté',
      FR_BRE: 'Brittany',
      FR_CVL: 'Centre-Val de Loire',
      FR_GES: 'Grand Est',
      FR_HDF: 'Hauts-de-France',
      FR_IDF: 'Île-de-France',
      FR_NOR: 'Normandy',
      FR_NAQ: 'Nouvelle-Aquitaine',
      FR_OCC: 'Occitanie',
      FR_PDL: 'Pays de la Loire',
      FR_PAC: "Provence-Alpes-Côte d'Azur",
    },
  },
  IN: {
    name: 'India',
    regions: {
      AN: 'Andaman and Nicobar Islands',
      AP: 'Andhra Pradesh',
      AR: 'Arunachal Pradesh',
      AS: 'Assam',
      BR: 'Bihar',
      CH: 'Chandigarh',
      CG: 'Chhattisgarh',
      DH: 'Dadra and Nagar Haveli and Daman and Diu', // Combined UT
      DL: 'Delhi',
      GA: 'Goa',
      GJ: 'Gujarat',
      HR: 'Haryana',
      HP: 'Himachal Pradesh',
      JK: 'Jammu and Kashmir',
      JH: 'Jharkhand',
      KA: 'Karnataka',
      KL: 'Kerala',
      LA: 'Ladakh',
      LD: 'Lakshadweep',
      MP: 'Madhya Pradesh',
      MH: 'Maharashtra',
      MN: 'Manipur',
      ML: 'Meghalaya',
      MZ: 'Mizoram',
      NL: 'Nagaland',
      OD: 'Odisha',
      PY: 'Puducherry',
      PB: 'Punjab',
      RJ: 'Rajasthan',
      SK: 'Sikkim',
      TN: 'Tamil Nadu',
      TS: 'Telangana',
      TR: 'Tripura',
      UP: 'Uttar Pradesh',
      UK: 'Uttarakhand',
      WB: 'West Bengal',
    },
  },
  CN: {
    name: 'China',
    regions: {
      AH: 'Anhui',
      BJ: 'Beijing', // Municipality
      CQ: 'Chongqing', // Municipality
      FJ: 'Fujian',
      GS: 'Gansu',
      GD: 'Guangdong',
      GX: 'Guangxi Zhuang Autonomous Region',
      GZ: 'Guizhou',
      HA: 'Henan',
      HE: 'Hebei',
      HL: 'Heilongjiang',
      HI: 'Hainan',
      HK: 'Hong Kong Special Administrative Region',
      HB: 'Hubei',
      HN: 'Hunan',
      NM: 'Inner Mongolia Autonomous Region',
      JS: 'Jiangsu',
      JX: 'Jiangxi',
      JL: 'Jilin',
      LN: 'Liaoning',
      MO: 'Macau Special Administrative Region',
      NX: 'Ningxia Hui Autonomous Region',
      QH: 'Qinghai',
      SN: 'Shaanxi',
      SD: 'Shandong',
      SH: 'Shanghai', // Municipality
      SX: 'Shanxi',
      SC: 'Sichuan',
      TJ: 'Tianjin', // Municipality
      TW: 'Taiwan', // Claimed province
      XJ: 'Xinjiang Uyghur Autonomous Region',
      XZ: 'Tibet Autonomous Region',
      YN: 'Yunnan',
      ZJ: 'Zhejiang',
    },
  },
  JP: { name: 'Japan', regions: {} },
  BR: { name: 'Brazil', regions: {} },
  RU: { name: 'Russia', regions: {} },
  ZA: { name: 'South Africa', regions: {} },
  MX: { name: 'Mexico', regions: {} },
  KR: { name: 'South Korea', regions: {} },
  ES: { name: 'Spain', regions: {} },
  IT: { name: 'Italy', regions: {} },
  ID: { name: 'Indonesia', regions: {} },
  NG: { name: 'Nigeria', regions: {} },
  EG: { name: 'Egypt', regions: {} },
  SE: { name: 'Sweden', regions: {} },
  CH: { name: 'Switzerland', regions: {} },
  AR: { name: 'Argentina', regions: {} },
  PL: { name: 'Poland', regions: {} },
  NO: { name: 'Norway', regions: {} },
  DK: { name: 'Denmark', regions: {} },
  FI: { name: 'Finland', regions: {} },
  SG: { name: 'Singapore', regions: {} },
  MY: { name: 'Malaysia', regions: {} },
  TH: { name: 'Thailand', regions: {} },
  IE: { name: 'Ireland', regions: {} },
  NZ: { name: 'New Zealand', regions: {} },
  CL: { name: 'Chile', regions: {} },
  CO: { name: 'Colombia', regions: {} },
  PE: { name: 'Peru', regions: {} },
  VN: { name: 'Vietnam', regions: {} },
  AE: { name: 'United Arab Emirates', regions: {} },
  SA: { name: 'Saudi Arabia', regions: {} },
  TR: { name: 'Turkey', regions: {} },
  BE: { name: 'Belgium', regions: {} },
  NL: { name: 'Netherlands', regions: {} },
  AT: { name: 'Austria', regions: {} },
  GR: { name: 'Greece', regions: {} },
  CZ: { name: 'Czech Republic', regions: {} },
  PT: { name: 'Portugal', regions: {} },
  HU: { name: 'Hungary', regions: {} },
  RO: { name: 'Romania', regions: {} },
  BD: { name: 'Bangladesh', regions: {} },
  PK: { name: 'Pakistan', regions: {} },
  KE: { name: 'Kenya', regions: {} },
  MA: { name: 'Morocco', regions: {} },
  GH: { name: 'Ghana', regions: {} },
  TZ: { name: 'Tanzania', regions: {} },
  UG: { name: 'Uganda', regions: {} },
  ET: { name: 'Ethiopia', regions: {} },
  ZM: { name: 'Zambia', regions: {} },
  ZW: { name: 'Zimbabwe', regions: {} },
  AL: { name: 'Albania', regions: {} },
  BA: { name: 'Bosnia and Herzegovina', regions: {} },
  HR: { name: 'Croatia', regions: {} },
  SK: { name: 'Slovakia', regions: {} },
  SI: { name: 'Slovenia', regions: {} },
  LT: { name: 'Lithuania', regions: {} },
  LV: { name: 'Latvia', regions: {} },
  EE: { name: 'Estonia', regions: {} },
  IS: { name: 'Iceland', regions: {} },
  MT: { name: 'Malta', regions: {} },
  CY: { name: 'Cyprus', regions: {} },
  LU: { name: 'Luxembourg', regions: {} },
  MC: { name: 'Monaco', regions: {} },
  LI: { name: 'Liechtenstein', regions: {} },
  SM: { name: 'San Marino', regions: {} },
  VA: { name: 'Holy See (Vatican City State)', regions: {} },
  AD: { name: 'Andorra', regions: {} },
  FO: { name: 'Faroe Islands', regions: {} },
  GL: { name: 'Greenland', regions: {} },
  GP: { name: 'Guadeloupe', regions: {} },
  MQ: { name: 'Martinique', regions: {} },
  GF: { name: 'French Guiana', regions: {} },
  RE: { name: 'Réunion', regions: {} },
  YT: { name: 'Mayotte', regions: {} },
  NC: { name: 'New Caledonia', regions: {} },
  PF: { name: 'French Polynesia', regions: {} },
  WF: { name: 'Wallis and Futuna', regions: {} },
  TF: { name: 'French Southern Territories', regions: {} },
  KI: { name: 'Kiribati', regions: {} },
  MH: { name: 'Marshall Islands', regions: {} },
  FM: { name: 'Micronesia (Federated States of)', regions: {} },
  NR: { name: 'Nauru', regions: {} },
  PW: { name: 'Palau', regions: {} },
  SB: { name: 'Solomon Islands', regions: {} },
  TV: { name: 'Tuvalu', regions: {} },
  VU: { name: 'Vanuatu', regions: {} },
  FJ: { name: 'Fiji', regions: {} },
  PG: { name: 'Papua New Guinea', regions: {} },
  TL: { name: 'Timor-Leste', regions: {} },
  BN: { name: 'Brunei Darussalam', regions: {} },
  KH: { name: 'Cambodia', regions: {} },
  LA: { name: "Lao People's Democratic Republic", regions: {} },
  MM: { name: 'Myanmar', regions: {} },
  NP: { name: 'Nepal', regions: {} },
  BT: { name: 'Bhutan', regions: {} },
  MV: { name: 'Maldives', regions: {} },
  LK: { name: 'Sri Lanka', regions: {} },
  AF: { name: 'Afghanistan', regions: {} },
  IR: { name: 'Iran (Islamic Republic of)', regions: {} },
  IQ: { name: 'Iraq', regions: {} },
  JO: { name: 'Jordan', regions: {} },
  KW: { name: 'Kuwait', regions: {} },
  LB: { name: 'Lebanon', regions: {} },
  OM: { name: 'Oman', regions: {} },
  QA: { name: 'Qatar', regions: {} },
  SY: { name: 'Syrian Arab Republic', regions: {} },
  YE: { name: 'Yemen', regions: {} },
  PS: { name: 'Palestine, State of', regions: {} },
  LY: { name: 'Libya', regions: {} },
  TN: { name: 'Tunisia', regions: {} },
  DZ: { name: 'Algeria', regions: {} },
  SD: { name: 'Sudan', regions: {} },
  SO: { name: 'Somalia', regions: {} },
  DJ: { name: 'Djibouti', regions: {} },
  CM: { name: 'Cameroon', regions: {} },
  CI: { name: "Côte d'Ivoire", regions: {} },
  SN: { name: 'Senegal', regions: {} },
  ML: { name: 'Mali', regions: {} },
  BF: { name: 'Burkina Faso', regions: {} },
  NE: { name: 'Niger', regions: {} },
  TG: { name: 'Togo', regions: {} },
  BJ: { name: 'Benin', regions: {} },
  GA: { name: 'Gabon', regions: {} },
  CG: { name: 'Congo', regions: {} },
  CD: { name: 'Congo (Democratic Republic of the)', regions: {} },
  AO: { name: 'Angola', regions: {} },
  MZ: { name: 'Mozambique', regions: {} },
  MG: { name: 'Madagascar', regions: {} },
  MW: { name: 'Malawi', regions: {} },
  NA: { name: 'Namibia', regions: {} },
  BW: { name: 'Botswana', regions: {} },
  LS: { name: 'Lesotho', regions: {} },
  SZ: { name: 'Eswatini (Swaziland)', regions: {} },
  MR: { name: 'Mauritania', regions: {} },
  ER: { name: 'Eritrea', regions: {} },
  GY: { name: 'Guyana', regions: {} },
  SR: { name: 'Suriname', regions: {} },
  PY: { name: 'Paraguay', regions: {} },
  UY: { name: 'Uruguay', regions: {} },
  EC: { name: 'Ecuador', regions: {} },
  VE: { name: 'Venezuela', regions: {} },
  BO: { name: 'Bolivia (Plurinational State of)', regions: {} },
  GT: { name: 'Guatemala', regions: {} },
  HN: { name: 'Honduras', regions: {} },
  SV: { name: 'El Salvador', regions: {} },
  NI: { name: 'Nicaragua', regions: {} },
  CR: { name: 'Costa Rica', regions: {} },
  PA: { name: 'Panama', regions: {} },
  CU: { name: 'Cuba', regions: {} },
  DO: { name: 'Dominican Republic', regions: {} },
  HT: { name: 'Haiti', regions: {} },
  JM: { name: 'Jamaica', regions: {} },
  TT: { name: 'Trinidad and Tobago', regions: {} },
  BB: { name: 'Barbados', regions: {} },
  BS: { name: 'Bahamas', regions: {} },
  BZ: { name: 'Belize', regions: {} },
});

export const STATE_LOCALES = [
  'en-US', // United States
  'en-AU', // Australia
  'en-IN', // India
  'en-BR', // Brazil
  'en-MX', // Mexico
  'en-DE', // Germany
  'en-NG', // Nigeria
  'en-MY', // Malaysia
  'en-SD', // Sudan
  'en-SS', // South Sudan
];

export const PROVINCE_LOCALES = [
  'en-AF', // Afghanistan
  'en-DZ', // Algeria
  'en-AO', // Angola
  'en-AR', // Argentina
  'en-BE', // Belgium
  'en-KH', // Cambodia
  'en-CL', // Chile
  'en-CN', // China
  'en-CU', // Cuba
  'en-DO', // Dominican Republic
  'en-EC', // Ecuador
  'en-IR', // Iran
  'en-IT', // Italy
  'en-KE', // Kenya
  'en-LA', // Laos
  'en-MZ', // Mozambique
  'en-NL', // Netherlands
  'en-PK', // Pakistan
  'en-PE', // Peru
  'en-PH', // Philippines
  'en-ZA', // South Africa
  'en-ES', // Spain
  'en-TH', // Thailand
  'en-TR', // Turkey
  'en-VN', // Vietnam
  'en-ZM', // Zambia
  'en-ZW', // Zimbabwe
];
